import { Tag } from "antd";
import React from "react";

export const renderStatusTag = (
  statusId: string | number | undefined,
  statusOptions: {
    value: string | number;
    label: any;
    color?: string;
  }[],
): React.ReactNode => {
  if (!statusId) return null;

  const status = statusOptions.find(
    (s) => String(s.value) === String(statusId),
  );

  if (!status) return null;

  const color = status.color || "#52c41a";

  const hexToRgba = (hex: string, alpha = 0.08) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  return (
    <Tag
      style={{
        color,
        backgroundColor: hexToRgba(color, 0.08),
        border: `1px solid ${hexToRgba(color, 0.35)}`,
        fontSize: 12,
        lineHeight: "18px",
        padding: "0 8px",
        borderRadius: 4,
      }}
    >
      {status.label}
    </Tag>
  );
};
